export default __webpack_public_path__ + "static/media/crown.49dc35c5.png";